// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2orqQ","title":"ClientReferral_title__SCNOc","itemText":"ClientReferral_itemText__31ijR"};